import request from '@/utils/request'

export function register (params) {
  return request({
    method: 'post',
    data: {
      do: 'register',
      ...params
    }
  })
}

//  一键注册
export function getRegisterAccount () {
  return request({
    method: 'get',
    params: {
      do: 'getRegisterAccount'
    }
  })
}

// 修改密码
export function updatePassword (params) {
  return request({
    method: 'post',
    data: {
      do: 'updatePassword',
      ...params
    }
  })
}

// 绑定手机
export function bindPhone (params) {
  return request({
    method: 'post',
    data: {
      do: 'bindPhone',
      ...params
    }
  })
}

// 重置密码
export function resetPassword (params) {
  return request({
    method: 'post',
    data: {
      do: 'resetPassword',
      ...params
    }
  })
}
